module.exports = __webpack_public_path__ + "static/media/dodge-go-drive.8f2515bf.jpg";